import { render } from "./Settings.vue?vue&type=template&id=574f2fa3&scoped=true"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-574f2fa3"

export default script